import { useEffect, useState } from "react";
import {
  getRunnerCompetitionList,
  getRunnerCompetitionPastList,
  RunnerCompetitionDto,
} from "../../../../../../api/runner-competition";

export const useRabbitFestivalCompetitions = () => {
  const [isFirst, setIsFirst] = useState(true);
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(new Date().getFullYear());
  const [bannerCompetitions, setBannerCompetitions] = useState<
    RunnerCompetitionDto[]
  >([]);
  const [competitions, setCompetitions] = useState<RunnerCompetitionDto[]>([]);

  const getCompetitions = async () => {
    try {
      const res = await getRunnerCompetitionList();
      setBannerCompetitions(res);
      setTimeout(() => {
        setIsFirst(false);
      }, 50);
    } catch (e) {
      console.error(e);
    }
  };

  const getPastList = async () => {
    setLoading(true);
    try {
      const res = await getRunnerCompetitionPastList(year);
      setCompetitions(res);
      setTimeout(() => {
        setLoading(false);
      }, 50);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getPastList();
  }, [year]);

  useEffect(() => {
    getCompetitions();
  }, []);

  return {
    bannerCompetitions,
    competitions,
    loading,
    isFirst,
    year,
    setYear,
  };
};
